export const defaultLocale = 'en' as const;
